import { render, staticRenderFns } from "./congratulations.vue?vue&type=template&id=bf0708ea&scoped=true"
import script from "./congratulations.vue?vue&type=script&lang=js"
export * from "./congratulations.vue?vue&type=script&lang=js"
import style0 from "./congratulations.vue?vue&type=style&index=0&id=bf0708ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0708ea",
  null
  
)

export default component.exports